//BFSG
import * as React from 'react'
import EecTracking from 'theme/atoms/EecTracking'
import styled from 'styled-components'
import theme from 'theme'
import Link from 'theme/atoms/Link'

import * as t from './types'
import ImageItem from './ImageItem'
import withDy from './withDy'
import useTranslations from 'hooks/useTranslations'
import withTranslations from './withTranslations'

export default withTranslations(withDy(function ImageList(props: t.Props) {
  const t = useTranslations<'organisms-dual-image-list'>()
  const imageItems = props.imageItems
  return (
    <EecTracking
      config={props.eecTracking}
      gridArea={props.gridArea}
      threshold={1}
    >
      <Wrapper className="ImageList" data-cy-ctx="organisms/DualImageList">
        <div className="brand-wrapper">
          {imageItems.map((item, i) => (
            <Link
              key={item.title}
              to={item.link}
              className="teaser-wrapper"
              aria-label={t.asText(false, 'BFSG_navigate_to_content')}
            >
              {' '}
              <ImageItem
                title={item.title}
                imgSrc={props.context.optImgs[i]}
                linkLabel={item.linkLabel}
                link={item.link}
              />
            </Link>
          ))}
        </div>
      </Wrapper>
    </EecTracking>
  )
}))

const Wrapper = styled.div`
  max-width: 355px;
  margin: auto;
  @media (min-width: ${theme.ms.MD}px) {
    max-width: 100%;
  }
  > .brand-wrapper {
    display: grid;
    grid-row-gap: ${theme.spacing('m')};
    max-width: 355px;

    @media (min-width: ${theme.ms.MD}px) {
      grid-template-columns: 1fr 1fr;
      grid-column-gap: ${theme.spacing('s')};
      grid-template-columns: fit-conten;
      justify-content: space-around;
      max-width: 100%;
    }
    @media (min-width: ${theme.ms.LG}px) {
      grid-template-columns: 1fr 1fr;
      grid-column-gap: ${theme.spacing('m')};
      grid-template-columns: fit-conten;
      justify-content: space-around;
    }
    > .teaser-wrapper {
      text-align: left;
      max-width: 355px;
      @media (min-width: ${theme.ms.MD}px) {
        margin-bottom: 0px;
        max-width: 100%;
        height: 240px;
      }
      @media (min-width: ${theme.ms.LG}px) {
        height: 430px;
      }
    }
  }
`
